/* GLLF Site search (v1) · adds "Across the farm" to the header search and the search page.
   Products and collections stay first (Shopify search); this adds the rest of the site after them:
   pages and tools from the menus, Simulator wiki, Farm trip guides, Field guide, farms and upcoming events.
   The index comes from small theme sections (sections/gllf-sx-*.liquid), loaded on the first search and kept for the day. */
(function () {
  'use strict';
  if (window.GLLFSiteSearch) return;
  var VER = 2, ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var TYPES = [
    { id: 'menus', tag: 'Page', w: 30 },
    { id: 'trips', tag: 'Farm trips', pre: 'pages/farm-trips/', w: 16 },
    { id: 'wiki', tag: 'Simulator wiki', pre: 'pages/wiki/', w: 10 },
    { id: 'guide', tag: 'Field guide', pre: 'pages/field-guide/', w: 10 },
    { id: 'farms', tag: 'Farm', pre: 'pages/farms/', w: 8 },
    { id: 'events', tag: 'Event', pre: 'pages/event/', w: 6 }
  ];
  var DATA = {}, LOADING = {}, waiters = [];
  var today = (function () { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); })();

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return ' ' + String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’®™]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }
  function mark(text, toks) {
    var t = esc(text); if (!toks.length) return t;
    var re = new RegExp('(^|[^a-z0-9])(' + toks.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'gi');
    return t.replace(re, '$1<mark>$2</mark>');
  }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { try { localStorage.removeItem(k); } catch (e2) {} } }
  function day(iso) { try { return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); } catch (e) { return iso; } }

  /* ---------- index ---------- */
  function getSx(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('sx_' + r.status); return r.text();
    }).then(function (html) {
      var m = /<script type="application\/json" data-gllf-sx>([\s\S]*?)<\/script>/.exec(html);
      if (!m) throw new Error('sx_missing'); return JSON.parse(m[1]);
    });
  }
  function sxUrl(id, more) { return ROOT + '?section_id=gllf-sx-' + id + (more || ''); }
  /* the next page comes from the section's own next-page link (cursor or page number), with the section id added */
  function nextUrl(id, nx) {
    try { var u = new URL(nx, location.origin); if (u.origin !== location.origin) return null; u.searchParams.set('section_id', 'gllf-sx-' + id); return u.pathname + u.search; } catch (e) { return null; }
  }
  function prep(t, rows) {
    var out = [], seen = {};
    rows.forEach(function (r) {
      if (!r || !r[0] || !r[1]) return;
      var url, sub = r[2] || '', extra = r[3] || '', when = '', wl = '';
      if (t.id === 'menus') {
        url = String(r[1]);
        if (url.charAt(0) !== '/' || /^\/account\/login/.test(url)) return;
        if (seen[url]) {
          var o = seen[url];
          if (r[2] && String(r[2]).trim() === o.t) { o.x += norm(o.t); o.t = String(r[0]).trim(); o.n = norm(o.t); o.s = String(r[2]).trim(); }
          else o.x += norm(r[0]);
          return;
        }
      } else url = ROOT + t.pre + r[1];
      if (t.id === 'events') {
        var last = r[5] || r[4] || '';
        if (last && last < today) return;
        if (r[4] && r[4] >= today) { when = r[4]; wl = day(r[4]); } else if (r[5]) { when = today; wl = 'Now through ' + day(r[5]); }
      }
      var tag = t.tag;
      if (t.id === 'menus') tag = /^\/collections\//.test(url) ? 'Collection' : /^\/blogs\//.test(url) ? 'Blog' : 'Page';
      var e = { t: String(r[0]).trim(), u: url, s: sub, w: when, wl: wl, tag: tag, type: t, n: norm(r[0]), x: norm(sub + ' ' + extra + ' ' + tag) };
      if (t.id === 'menus') seen[url] = e;
      out.push(e);
    });
    return out;
  }
  function loadType(t) {
    if (DATA[t.id]) return Promise.resolve(DATA[t.id]);
    if (LOADING[t.id]) return LOADING[t.id];
    var key = 'gllf_sx' + VER + '_' + t.id, c = lsGet(key);
    if (c && c.v === today && Array.isArray(c.d)) { DATA[t.id] = prep(t, c.d); return Promise.resolve(DATA[t.id]); }
    var rows = [], seen = {};
    function add(j) {
      var fresh = 0;
      (j.d || []).forEach(function (r) { var k = r && r[1]; if (!k) return; if (t.id !== 'menus') { if (seen[k]) return; seen[k] = 1; } rows.push(r); fresh++; });
      return fresh;
    }
    function step(url, no) {
      return getSx(url).then(function (j) {
        if (!add(j) && no > 1) return;             /* same page again: stop, nothing doubled */
        if (no >= Math.min(+j.n || 1, 40)) return;
        return step((j.nx && nextUrl(t.id, j.nx)) || sxUrl(t.id, '&page=' + (no + 1)), no + 1);
      });
    }
    LOADING[t.id] = step(sxUrl(t.id), 1).catch(function () {}).then(function () {
      if (rows.length) lsSet(key, { v: today, d: rows });
      DATA[t.id] = prep(t, rows); return DATA[t.id];
    }).catch(function () { DATA[t.id] = []; return DATA[t.id]; }).then(function (d) { delete LOADING[t.id]; changed(); return d; });
    return LOADING[t.id];
  }
  var started = false;
  function warm() {
    if (started) return; started = true;
    /* small ones first, farms and events after */
    Promise.all(TYPES.slice(0, 4).map(loadType)).then(function () { return Promise.all(TYPES.slice(4).map(loadType)); });
  }
  function ready() { return TYPES.every(function (t) { return DATA[t.id]; }); }
  function changed() { waiters.forEach(function (fn) { try { fn(); } catch (e) {} }); }

  /* ---------- matching ---------- */
  function search(q, limit, skip) {
    var qn = norm(q), toks = qn.trim().split(' ').filter(Boolean);
    if (!toks.length || qn.trim().length < 2) return { list: [], total: 0, toks: [] };
    var hits = [];
    TYPES.forEach(function (t) {
      (DATA[t.id] || []).forEach(function (e) {
        var sc = 0;
        for (var i = 0; i < toks.length; i++) {
          var k = ' ' + toks[i];
          if (e.n.indexOf(k) >= 0) sc += 10; else if (e.x.indexOf(k) >= 0) sc += 4; else return;
        }
        if (e.n === qn) sc += 40; else if (e.n.indexOf(qn) === 0) sc += 22; else if (e.n.indexOf(' ' + qn.trim()) >= 0) sc += 10;
        sc += t.w - Math.min(e.t.length, 60) / 15;
        if (e.w) { var dd = (Date.parse(e.w) - Date.parse(today)) / 864e5; if (dd <= 45) sc += 4; }
        if (skip && skip[e.u.split('?')[0].split('#')[0]]) return;
        hits.push({ e: e, s: sc });
      });
    });
    hits.sort(function (a, b) { return b.s - a.s; });
    var per = {}, out = [], spare = [];
    hits.forEach(function (h) {
      var id = h.e.type.id; if (out.length >= limit) return;
      if ((per[id] || 0) < 3) { per[id] = (per[id] || 0) + 1; out.push(h.e); } else spare.push(h.e);
    });
    for (var i = 0; out.length < limit && i < spare.length; i++) out.push(spare[i]);
    out.sort(function (a, b) { return (TYPES.indexOf(a.type) - TYPES.indexOf(b.type)) || (a.type.id === 'events' ? (a.w < b.w ? -1 : a.w > b.w ? 1 : 0) : 0); });
    return { list: out, total: hits.length, toks: toks };
  }
  function subLine(e) {
    var bits = [];
    if (e.wl) bits.push(e.wl);
    if (e.s) bits.push(e.s);
    return bits.join(' · ');
  }
  function rowHTML(e, q, toks) {
    var sub = subLine(e);
    return '<li role="option" aria-selected="false"><a class="gllf-ss__row gs-site__row" href="' + esc(e.u) + '" data-ss-go="' + esc(q) + '">' +
      '<span class="gllf-ss__tag gs-site__tag gs-site__tag--' + e.type.id + '">' + esc(e.tag) + '</span>' +
      '<span class="gs-site__t"><b>' + mark(e.t, toks) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>' +
      '<span aria-hidden="true">›</span></a></li>';
  }

  /* ---------- header search panels ---------- */
  var PHONE = window.matchMedia('(max-width: 749px)');
  function inputFor(panel) { return document.querySelector('input[aria-controls="' + panel.id + '"]'); }
  function inject(panel) {
    var bodyEl = panel.querySelector('.gs-body'), input = inputFor(panel);
    if (!bodyEl || !input) return;
    var old = bodyEl.querySelector('[data-gs-site]'); if (old) old.remove();
    var emp = bodyEl.querySelector('.gllf-ss__empty'); if (emp) emp.classList.remove('gs-site-has');
    var q = input.value.trim(), sc = panel.querySelector('.gs-scope[aria-checked="true"]'), scope = sc ? sc.getAttribute('data-gs-scope') : 'all';
    if (q.length < 2 || (scope !== 'all' && scope !== 'learn') || bodyEl.querySelector('.gllf-ss__loading')) return;
    warm();
    var skip = {};
    bodyEl.querySelectorAll('a[href]').forEach(function (a) { skip[a.getAttribute('href').split('?')[0].split('#')[0]] = 1; });
    var r = search(q, scope === 'learn' ? 10 : (PHONE.matches ? 5 : 8), skip);
    var waiting = !ready();
    if (!r.list.length && !waiting) return;
    var html = '<div class="gllf-ss__sec gs-site" data-gs-site><div class="gllf-ss__head"><span>Across the farm</span>' +
      (waiting ? '<span class="gs-site__busy" role="status">Searching the farm…</span>' : '') + '</div>' +
      (r.list.length ? '<ul class="gllf-ss__list gs-site__list" role="listbox" aria-label="Across the farm">' + r.list.map(function (e) { return rowHTML(e, q, r.toks); }).join('') + '</ul>' : '') +
      (!waiting && r.total > r.list.length ? '<a class="gllf-ss__link gs-site__more" href="' + esc(ROOT + 'search?q=' + encodeURIComponent(q)) + '#gllf-site-results" data-ss-go="' + esc(q) + '">See all ' + r.total + ' farm results</a>' : '') +
      '</div>';
    var cta = bodyEl.querySelector(':scope > .gllf-ss__cta[type="submit"]'), empty = bodyEl.querySelector(':scope > .gllf-ss__empty');
    var wrap = document.createElement('div'); wrap.innerHTML = html;
    var node = wrap.firstChild;
    if (empty && r.list.length) { empty.classList.add('gs-site-has'); bodyEl.insertBefore(node, empty); }
    else if (cta) bodyEl.insertBefore(node, cta); else bodyEl.appendChild(node);
  }
  var watched = [];
  function watch(panel) {
    if (!panel || panel.__gsSite) return; panel.__gsSite = 1; watched.push(panel);
    new MutationObserver(function () { inject(panel); }).observe(panel, { childList: true });
    inject(panel);
  }
  waiters.push(function () { watched.forEach(function (p) { if (!p.hidden) inject(p); }); });
  function onFocus(e) {
    var i = e.target; if (!i || !i.matches || !i.matches('.gs-form input[type="search"], .gs-form input[name="q"]')) return;
    var id = i.getAttribute('aria-controls'), p = id && document.getElementById(id);
    if (p) watch(p);
    shortPh();
  }
  /* the full placeholder is cut off in the narrow phone field, so phones get a short one that fits */
  function shortPh() {
    if (!PHONE.matches) return;
    document.querySelectorAll('.gs-form--desktop input[type="search"], .gs-form--desktop input[name="q"]').forEach(function (i) { if (i.placeholder.length > 16) i.placeholder = 'Search the farm'; });
  }
  document.addEventListener('focusin', onFocus, true);
  document.addEventListener('input', function (e) { onFocus(e); if (e.target && e.target.closest && e.target.closest('.gs-form')) warm(); }, true);

  /* ---------- search results page ---------- */
  function searchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (q.length < 2) return;
    var after = document.querySelector('.template-search__results') || document.querySelector('.template-search__header');
    if (!after) return;
    var box = document.createElement('section');
    box.className = 'gs-sitepage page-width'; box.id = 'gllf-site-results'; box.setAttribute('aria-label', 'Across the farm');
    after.insertAdjacentElement('afterend', box);
    var shown = 24;
    box.addEventListener('click', function (e) { if (e.target.closest('[data-gs-more]')) { shown += 24; draw(); } });
    function draw() {
      var r = search(q, shown, null), waiting = !ready();
      box.innerHTML = '<div class="gs-sitepage__head"><h2>Across the farm</h2><p>' +
        (waiting && !(r.list.length) ? 'Searching guides, the wiki, farms and events…' :
          (r.list.length ? 'Guides, tools, the Simulator wiki, farms and events for “' + esc(q) + '”' + (waiting ? ' (still looking…)' : '') : 'Nothing else on the site matches “' + esc(q) + '”.')) +
        '</p></div>' + (r.list.length ? '<ul class="gs-sitepage__list" role="list">' + r.list.map(function (e) {
          var sub = subLine(e);
          return '<li><a class="gs-sitepage__card" href="' + esc(e.u) + '"><span class="gllf-ss__tag gs-site__tag gs-site__tag--' + e.type.id + '">' + esc(e.tag) + '</span><b>' + mark(e.t, r.toks) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</a></li>';
        }).join('') + '</ul>' : '') +
        (!waiting && r.total > r.list.length ? '<button type="button" class="gs-sitepage__more" data-gs-more>Show more (' + (r.total - r.list.length) + ' more)</button>' : '');
      if (!waiting && location.hash === '#gllf-site-results' && !box.__scrolled) { box.__scrolled = 1; box.scrollIntoView({ block: 'start' }); }
    }
    waiters.push(draw); warm(); draw();
  }

  window.GLLFSiteSearch = { search: search, warm: warm, inject: inject };
  function boot() { searchPage(); shortPh(); setTimeout(shortPh, 1200); try { for (var i = localStorage.length - 1; i >= 0; i--) { var k = localStorage.key(i); if (k && /^gllf_sx\d+_/.test(k) && k.indexOf('gllf_sx' + VER + '_') !== 0) localStorage.removeItem(k); } } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(shortPh, 50); });
})();
